import React from 'react'
import {  YapContentPreview, YapHeaderButton as CBHeaderButton,  YapAssetImage as CBAssetImage, YapContentPreviewsModal as CBContentPreviewsModal, useYapPageState as useCBPageState, YapContentBuilderIconProviderContext as CBMessageBuilderIconProviderContext } from '@yapstudios/yap-content-builder'
import { components, componentTemplates, MessageHeaderComponent, TextComponent, SingleImageComponent, LearnMoreButtonComponent, ActionButtonComponent, RequestInformationButtonComponent, UniversityComponent } from './CollegeboardComponentLibrary.js'
import { styles, fonts } from "./CBStyles.js"
import { mapAriaHiddenArray } from './isAriaHidden.js'

export interface CBMessagePage {
    sections : Record<string, any>[]
}

export interface CBMessagePreviewProps {
    /**
     * Width of preview
     */
    width: number;

    /**
     * Page to render. This can be passed, or if null, page can be built by passing the other properties
     */
    page?: CBMessagePage

    /**
     * Page title
     */
    title?: string

    /**
     * Page caption. i.e. AUG 12
     */
    caption?: string

    /**
     * Message body text
     */
    body?: string

    /**
     * Image
     */
    image?: string

    /**
     * Image alt text
     */
    imageDescription?: string

    /**
     * Institution title
     */
    institutionTitle?: string

    /**
     * Institution location
     */
    institutionLocation?: string

    /**
     * Institution logo 
     */
    institutionLogo?: string

    /**
     * Institution logo alt text
     */
    institutionLogoDescription?: string    

    /**
     * Elements to hide from screen readers. Visible by default.
     */    
    ariaHidden?: ('title' | 'caption' | 'image' | 'body' | 'institutionTitle' | 'institutionLocation' | 'institutionLogo')[]

    /**
     * Action
     *  - learnMore          - [deeplink] Deeplink to institution page. Default title 'Explore More', Title & URL cannot be edited by default. 
     *  - requestInformation - [external] External browser web link. Default title 'Request Info'. Title & URL cannot be edited by default. 
     *  - embeddedRequestInformation - [external] External browser web link. Default title 'Request Info'. Title & URL cannot be edited by default. 
     *  - custom             - [internal] Internal college board action. Default title 'Action Button'. Both fields can be edited by user by default.
     *  - null               - Dont show an action
     */
    action?: 'actionLearnMore' | 'actionRequestInformation' | 'actionEmbeddedRequestInformation' | null | undefined
}

/**
 * Presents a preview of a message
 * @component
 */
function CBMessagePreview (props: CBMessagePreviewProps) {
    var page = props.page

    if (!page) {
        const ariaHiddenInstitutionMap = {
            'institutionTitle': 'title',
            'institutionLocation': 'subtitle',
            'institutionLogo': 'logo'
        }
        const ariaHiddenParagraphMap = {
            'body' : 'title'
        }
        page = {
            sections: [
                {
                    'type': 'message-header',
                    'props': {
                        'title': props.title ?? "title",
                        'caption': props.caption ?? "caption",
                        'coverImage' : {
                            src: props.image,
                            description: props.imageDescription
                        },
                        'coverImageDescription' : props.imageDescription,
                        'isPreview' : true,
                        "ariaHidden" : props.ariaHidden
                    }
                },
                {
                    "type": "institution",
                    "props": {
                        "title":  props.institutionTitle ?? "institutionTitle",
                        "subtitle": props.institutionLocation ?? "institutionLocation",
                        "iconURL": props.institutionLogo,
                        "ariaHidden" : mapAriaHiddenArray(ariaHiddenInstitutionMap, props.ariaHidden)
                    }
                },
                {
                    'type': 'paragraph',
                    'props': {
                        'title': props.body ?? 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                        "style": "body",
                        "align": "left",
                        "ariaHidden" : mapAriaHiddenArray(ariaHiddenParagraphMap, props.ariaHidden)
                    }
                },
            ]
        }

        if (props.action) {
            page.sections.push(
                { 
                    'type' : props.action,
                    'props' : {
                    }
                }
            )
        }
    }
    return <YapContentPreview components={components} styles={styles} fonts={fonts} {...props} page={page} />
}

export default CBMessagePreview